/**
 * Константы бокового меню.
 *
 * Держим РЯДОМ с компонентами sideBar, не в глобальном const.ts.
 * Принцип: feature-локальные значения живут в feature.
 *
 * При необходимости расширить позже:
 *   - SIDEBAR_WIDTH_COLLAPSED (если когда-то добавим свёрнутый режим)
 *   - LOGO_HEIGHT / FOOTER_HEIGHT (если нужно вычислять height-of-scroll)
 */

/** Ширина бокового меню на десктопе. */
export const SIDEBAR_WIDTH = 240;

/** Высота шапки sidebar'а (логотип). Совпадает с высотой mobile AppNavbar. */
export const SIDEBAR_HEADER_HEIGHT = 56;

/** Высота подвала sidebar'а (MenuPanel с глобальными действиями). */
export const SIDEBAR_FOOTER_HEIGHT = 72;

/** Высота одного пункта меню. */
export const MENU_ITEM_HEIGHT = 36;

/** Ключ для сохранения раскрытия групп в localStorage. */
export const MENU_COLLAPSE_STORAGE_KEY = "parallax:menu:collapse";